import { Link } from 'react-router';

import './InfoBox.css';

function InfoBox({header, children, href }) {
    let content = (
        <>
            <h3>{header}</h3>
            {children}
        </>
    )

    if (href) {
        return (
            <Link className='InfoBox InfoBox--link' to={href}>
                {content}
            </Link>
        )
    }

    return (
        <div className='InfoBox'>
            {content}
        </div>
    )
}

export default InfoBox